import { render, staticRenderFns } from "./tabsNav.vue?vue&type=template&id=5dc3ed45&scoped=true"
import script from "./tabsNav.vue?vue&type=script&lang=js"
export * from "./tabsNav.vue?vue&type=script&lang=js"
import style0 from "./tabsNav.vue?vue&type=style&index=0&id=5dc3ed45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3ed45",
  null
  
)

export default component.exports